export const keys = {
  all: ["ai-controller"] as const,
  getFilter: (orgId: string) => [...keys.all, orgId] as const
};
